import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { numbers } from '@material/slider';
import { TiposNotificacion } from '@models/base/identificadores.model';
import { NotificacionDto } from '@models/notificacion/notificacionDto.model';
import { UpdateNotificacionRequest } from '@models/notificacion/updateNotificacionRequest.model';
import { NotificacionesService } from '@services/notificaciones/notificaciones.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { interval, Subscription } from 'rxjs';

@Component({
  standalone: true,
  imports: [// Angular Core
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,

    // Angular CDK
    DragDropModule,
    LayoutModule,

    // Angular Material
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatListModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatChipsModule,
    MatBadgeModule,
    MatDividerModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,

    // Terceros
    NgxSpinnerModule],
  selector: 'app-dialog-notificaciones',
  templateUrl: './dialog-notificaciones.component.html',
  styleUrls: ['./dialog-notificaciones.component.css']
})
export class DialogNotificacionesComponent implements OnInit {

  notificaciones: NotificacionDto[] = []
  intervaloSubscripcion!: Subscription;
  notificacionesEliminando: Set<number> = new Set();
  constructor(
    private notificacionesService: NotificacionesService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {


  }


  ngOnInit(): void {
    this.GetAllByTipoNotificacion();

    this.intervaloSubscripcion = interval(60000).subscribe(() => {
      this.GetAllByTipoNotificacion()
    });
  }

  cantidadNoLeidas(): number {
    return this.notificaciones.length;
  }

  marcarComoLeida(notificacion: NotificacionDto) {
    let updateNotificacionRequest = new UpdateNotificacionRequest()
    updateNotificacionRequest.id = notificacion.id;
    this.notificacionesEliminando.add(updateNotificacionRequest.id);

    this.update(updateNotificacionRequest)
  }

  marcarTodasComoLeidas() {
    let ids:number[] =[]
    // Agregar todas al set de eliminando
    this.notificaciones.forEach(notificacion => {
      ids.push(notificacion.id)
      this.notificacionesEliminando.add(notificacion.id);
    });



    // Actualizar en el backend (ajusta según tu servicio)
    this.notificacionesService.setLecturaNotificaciones(ids).subscribe({
      next: () => {
        setTimeout(() => {
          // Limpiar todas las notificaciones
          this.notificaciones = [];
          this.notificacionesEliminando.clear();
        }, 300);
      },
      error: (error) => {
        // Si falla, limpiar el set
        this.notificacionesEliminando.clear();
        console.error('Error al marcar todas como leídas:', error);
      }
    });
  }

  GetAllByTipoNotificacion() {
    this.spinner.show('spListado')
    this.notificacionesService.getAllByTipoNotificacion(TiposNotificacion.NotificacionPush)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.notificaciones = data.filter(n => !n.estadoLectura);

        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  update(updateNotificacionRequest: UpdateNotificacionRequest) {
    this.spinner.show('spListado')
    this.notificaciones = this.notificaciones.filter(n => n.id !== updateNotificacionRequest.id);
    let ids:number[] =[]
    ids.push(updateNotificacionRequest.id)
    // Limpiar del set de eliminando
    this.notificacionesEliminando.delete(updateNotificacionRequest.id);
    this.notificacionesService.setLecturaNotificaciones(ids)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          // Esperar un poco para que se vea la animación
          setTimeout(() => {
            // Remover de la lista local
            this.notificaciones = this.notificaciones.filter(n => n.id !== updateNotificacionRequest.id);
            // Limpiar del set de eliminando
            this.notificacionesEliminando.delete(updateNotificacionRequest.id);
          }, 300); // 300ms es la duración de la animación
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  // Método helper para saber si una notificación se está eliminando
  estaEliminando(notificacion: NotificacionDto): boolean {
    return this.notificacionesEliminando.has(notificacion.id);
  }

  // Método para obtener el ID único de la notificación
  getNotificacionId(notificacion: NotificacionDto): number {
    return notificacion.id;
  }

  trackByItems(index: number, item: NotificacionDto): any {
    return this.getNotificacionId(item);
  }

  ngOnDestroy(): void {
    if (this.intervaloSubscripcion) {
      this.intervaloSubscripcion.unsubscribe();
    }
  }
}
